import { takeLatest, call, put, delay } from 'redux-saga/effects';
import Type from '@actionTypes';
import * as api from '../../../server';
import { message } from 'antd';
message.config({
  duration: 2,
  maxCount: 1,
});

// 登录成功处理逻辑
 function *handleLoginSuccess (res, action) {
  yield put({ type: 'RESET_ALL_REDUCER_STATE' })
  yield put({
    type: Type.LOGIN_SUCCESS,
    token: res.token,
  })
  const info = yield call(api.userInfo);
  yield put({
    type: Type.SET_USER,
    info,
  });
  const permissionTree = yield call(api.getPermission);
  // 菜单数组
  yield put({
    type: Type.SET_PERM,
    permissionTree,
  });
  //当前责任人
     const responsibleTree = yield call(api.getResponsible);
     yield put({
         type: Type.SET_RESPONSIBLE,
         responsibleTree,
     });

  sessionStorage.setItem('user', info.personName);
  sessionStorage.setItem('userCode', info.userCode);
  sessionStorage.setItem('token', res.token);
  sessionStorage.setItem('userID', info.userID);
  sessionStorage.setItem('exten', info.exten);
  sessionStorage.setItem('permissionTree', JSON.stringify(permissionTree));
  sessionStorage.setItem('responsibleTree', JSON.stringify(responsibleTree));
  sessionStorage.setItem('signature', info.signature);
  const sourceTree = yield call(api.searchDict)
  sessionStorage.setItem('sourceTree', JSON.stringify(sourceTree.dictionary))
  yield put({ type: Type.SET_DICT, sourceTree })
  const { cb = window.noop } = action
  yield call(cb, info.status, '')
}

export function* loginRequest(action) {
  try {
    const res = yield call(api.loginRequest, action.params)
    if (res.status === 0) {
      yield handleLoginSuccess(res, action)
    } else if (res.status === 5) {
      const { cb = window.noop } = action
      yield call(cb, res.status, res.phone);
      // yield put({ type: Type.SHOW_ERROR, info: res.description })
      yield put({ type: Type.LOGIN_FAILURE })
    } else {
      message.error(res.des);
      yield put({ type: Type.LOGIN_FAILURE })
    }
  } catch (error) {
    console.error(error)
  }
}
export function* vcodeRequest(action) {
  try {
    const res = yield call(api.vcode, action.params)
    if (res.status === 0) {
      yield handleLoginSuccess(res, action)
    }
  } catch (error) {
    console.error(error)
  }
}
//退出登录
export function* logoutRequest(action) {
  try {
    yield call(api.logout);
    const { cb = window.noop } = action
    yield call(cb)
    yield put({ type: Type.USER_LOGOUT_SUCCESS })
    yield put({ type: 'RESET_ALL_REDUCER_STATE' })

  } catch (error) {
  }
}
//修改密码
export function* changePwdRequest(action) {
  try {
    const res = yield call(api.changePassword, action.params);
    if (res.status === 0) {
      message.success(res.des);
      sessionStorage.clear();
      yield put({ type: Type.USER_LOGOUT_SUCCESS });
      setTimeout(() => {
        window.location.href = '/';
      }, 2000)
    } else {
      message.error(res.des);
    }
  } catch (error) {
  }
}

// geturl
export function* getBaseUrl() {
  try {
      const res = yield call(api.getBaseUrl);
      yield put({
          type: Type.SET_BASEURL,
          baseUrl: res.baseUrl
      })
  } catch (error) {
      message.error(error)
  }
}

export function* takeLoginRequest() {
  yield takeLatest(Type.LOGIN_REQUEST, loginRequest)
}
export function* takeVcodeRequest() {
  yield takeLatest(Type.GET_VCODE, vcodeRequest)
}
export function* logout() {
  yield takeLatest(Type.USER_LOGOUT, logoutRequest)
}
export function* changePwd() {
  yield takeLatest(Type.CHANGE_PWD, changePwdRequest)
}

export function* getBaseUrlRequest() {
  yield takeLatest(Type.GET_BASEURL, getBaseUrl)
}
